module.exports = __webpack_public_path__ + "img/logo-small.43819158.svg";